/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Route, Switch } from "react-router-dom";
import "./App.css";
import { Inspection } from "./components/Inspection/Inspection";
import speakAPI from "./libs/api/speak";
import { baseUrl } from "./libs/env";
import Error from "./erros/Error";
import { isLocalHosted } from "./libs/env";
import { useHistory } from "react-router-dom";
import SpeakAssessment from "./speech_pages/speak_test/SpeakAssessment";
import { size } from "lodash";
import { CustomOriginProvider } from "./components/custom_origin/CustomOriginContext";

export const getQuizId = () => {
  let id = window.location.pathname.split("/")[3];
  return id;
};

const SpeechApp = (props) => {
  let RoutePath = `/:speak/:quiz/:id`;

  const [items, setItems] = useState({});
  const [isLoaded, setIsLoaded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSystemRedirection, setIsSystemRedirection] = useState(false);
  const nextSectionaudioRef = useRef(null);
  let history = useHistory();
  if (isLocalHosted === false) {
    Inspection();
  }
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
      setTimeout(() => {
        speakAPI
        .get({ id: getQuizId() })
        .then((res) => res.json())
        .then((json) => {
          setIsLoaded(true);
          setItems(json);
        })
        .catch((error) => console.log(error.message));
      }, 50);

  }, []);

  const UpdateQuestion = (json) => {
    setIsSubmitting(false);
    setIsLoaded(true);
    setItems(json);
    scrollTop();
  }
  const playnextSectionAudio = async (json) => {
    if (nextSectionaudioRef.current) {
      try {
        await nextSectionaudioRef.current.play();
        nextSectionaudioRef.current.onended = () => {
          UpdateQuestion(json);
        };
      } catch (error) {
        UpdateQuestion(json);
        console.error("Error playing section audio:", error);
      }
    }
    else{
      UpdateQuestion(json);
    }
  };

  const submitQuiz = useCallback(
    (data, redirection) => {
      if (data.is_submit) {
        setIsSubmitting(true);
        speakAPI
          .post({ id: getQuizId(), data })
          .then((res) => res.json())
          .then((json) => {
            if(json && size(json.sections) > 0)
            {
              playnextSectionAudio(json);
            }
            else{
              setIsSubmitting(false);
              setIsLoaded(true);
              if (!redirection) {
                setItems(json);
                scrollTop();
              }
            }

            if (json.message === "Already submitted.") {
              localStorage.clear();
              setIsSystemRedirection(true);
              window.location.replace(
                `${baseUrl}/speak/student/tests/?task_completed=true`
              );
            }

            if (json.is_show_feedback === false) {
              setIsSystemRedirection(true);
              history.push("/stagging");
            }
          });
      } else {
        speakAPI
          .post({ id: getQuizId(), data })
          .then((res) => res.json())
          .then((json) => {
            if (redirection) {
              setIsSystemRedirection(true);
              window.location.replace(
                `${baseUrl}/speak/student/tests/?task_completed=true`
              );
            }
          });
      }
    },
    [history]
  );

  return (
    <>
      <Switch>
        <Route exact path={RoutePath}>
          { items.detail ? (
            <Error data={items} isLoaded={isLoaded} />
          ) : (
            <CustomOriginProvider userSource={items ? items.user_source: null}>
            <SpeakAssessment
              setIsSystemRedirection={setIsSystemRedirection}
              isSystemRedirection={isSystemRedirection}
              data={items}
              isLoaded={isLoaded}
              onSubmit={submitQuiz}
              isSubmitting={isSubmitting}
              nextSectionaudioRef={nextSectionaudioRef}
              setIsSubmitting={setIsSubmitting}
            />
            </CustomOriginProvider>
          )}
        </Route>
        <Route path={"/stagging"} render={() => (window.location = baseUrl)} />
        <Route exact path={`*`}>
          404 - Not fount
        </Route>
      </Switch>
    </>
  );
};

export default SpeechApp;
